import SmartContractModal from '@features/lockup/ui/smart-contracts-modal';
import Button from '@uikit/button';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './styles.module.scss';

interface Props {
  title: string;
  description?: string;
  className?: string;
  withoutSeparator?: boolean;
}

const LockHeader = ({ title, description, className, withoutSeparator }: Props) => {
  const [isShowSmartModal, setIsShowSmartModal] = useState<boolean>(false);

  return (
    <div className={classNames(className, styles.lockHeader, { [styles.withoutSeparator]: withoutSeparator })}>
      <div className={styles.lockHeaderItem}>
        <h1>{title}</h1>
      </div>

      {description ? (
        <div className={styles.lockHeaderItem}>
          <p dangerouslySetInnerHTML={{ __html: description }} />
          <Button type="white" onClick={() => setIsShowSmartModal(true)}>
            Abyss Lockup Smart Contracts
          </Button>
        </div>
      ) : null}

      {isShowSmartModal ? <SmartContractModal onClose={() => setIsShowSmartModal(false)} /> : null}
    </div>
  );
};
export default LockHeader;
